export const 
CANDIDATE_ACTIVATION_PENDING = "CANDIDATE_ACTIVATION_PENDING",
CANDIDATE_ACTIVATION_SUCCESS = "CANDIDATE_ACTIVATION_SUCCESS",
CANDIDATE_ACTIVATION_FAILURE = "CANDIDATE_ACTIVATION_FAILURE";